import { render, staticRenderFns } from "./Expense.vue?vue&type=template&id=1c85e238&scoped=true"
import script from "./Expense.vue?vue&type=script&lang=js"
export * from "./Expense.vue?vue&type=script&lang=js"
import style0 from "./Expense.vue?vue&type=style&index=0&id=1c85e238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c85e238",
  null
  
)

export default component.exports